import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import PrimeVue from "primevue/config";

import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

import InputText from "primevue/inputtext";
import Card from "primevue/card";
import Password from "primevue/password";
import Button from "primevue/button";
import Menubar from "primevue/menubar";
import Menu from "primevue/menu";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Image from "primevue/image";
import BlockUI from "primevue/blockui";
import Calendar from "primevue/calendar";
import Dialog from "primevue/dialog";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import Tooltip from "primevue/tooltip";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import DataView from "primevue/dataview";
import Sidebar from "primevue/sidebar";
import Slider from "primevue/slider";
import Chart from "primevue/chart";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

import "../node_modules/primevue/resources/themes/fluent-light/theme.css";
// import "../node_modules/primevue/resources/themes/luna-amber/theme.css";
import "../node_modules/primevue/resources/primevue.min.css";
import "../node_modules/primeicons/primeicons.css";
import "../node_modules/primeflex/primeflex.min.css";
import "../node_modules/leaflet/dist/leaflet.css";
import "@/assets/css/app.css";

import { Chart as ChartJS } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register([ChartDataLabels]);

const app = createApp(App);
app.use(PrimeVue);
app.use(ToastService);
app.use(ConfirmationService);
app.use(router);

app.component("InputText", InputText);
app.component("Card", Card);
app.component("Password", Password);
app.component("Button", Button);
app.component("Menubar", Menubar);
app.component("Menu", Menu);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Image", Image);
app.component("BlockUI", BlockUI);
app.component("Calendar", Calendar);
app.component("Dialog", Dialog);
app.component("InputSwitch", InputSwitch);
app.component("Checkbox", Checkbox);
app.component("Textarea", Textarea);
app.component("MultiSelect", MultiSelect);
app.component("Dropdown", Dropdown);
app.component("DataView", DataView);
app.component("Sidebar", Sidebar);
app.component("Slider", Slider);
app.component("Chart", Chart);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);

app.directive("Tooltip", Tooltip);

app.mount("#app");
